import { render, staticRenderFns } from "./regionActivistyCostAttribution.vue?vue&type=template&id=cd0e1d0c&scoped=true"
import script from "./regionActivistyCostAttribution.vue?vue&type=script&lang=js"
export * from "./regionActivistyCostAttribution.vue?vue&type=script&lang=js"
import style0 from "./regionActivistyCostAttribution.vue?vue&type=style&index=0&id=cd0e1d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0e1d0c",
  null
  
)

export default component.exports